export default "__VITE_ASSET__BjPY8mf4__"